module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsSAAALEgHS3X78AAABLElEQVQ4y7WVsXGDMBRAH5z7cGc1qHImiDJBklpDmA2SbOANwgYhO1i9N4jZADeqVJAJSCPuZJ2xjcGvQgg9ia//paTrOkKMkAVQAC9c5gCUQKWdbcOOJBQbIStgzXhq7aw6KfYr/fbvf4DqCqECvvox2tniSBxJD4CKf20II2QJvMfy1AipfJx6imulng1Q++e1EXIDkGyX+R54Yl4eU6Blfto+xq8zShvtbJPEeTwXqRFS+Z2djBGy8BlGsl3mLfAAfGpnywlSBfz65vPCSwGy6MPMF8DgBmln90E7HJ8tzm1CMOnQKt+0s7uTMZ6aVkMd51a8uhCKRjvbjBb7st7dnG7cibuJw1CsJpb28UG/Xea33hpD/Glns9SfxfVcUuAjvppUXH1jCYvlH2PFcIILmU0jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stock.png
// module id = qzMX
// module chunks = 1